import { Injectable } from "@angular/core";
import { ScriptService } from "./script.service";

@Injectable({
  providedIn: "root"
})
export class TrustedShopsService {

  enabled: boolean = false;

  constructor(private script: ScriptService) { }

  loadScript(): void {
    this.script.load('trustedshops').then().catch(error => console.log(error));
    this.enabled = true;
  }
}
